module.exports = __webpack_public_path__ + "static/media/search-block-bg.2e89e3e8.jpg";